export const SERVICE_TYPE = [
  { label: 'Pháp lý', value: 'legal' },
  { label: 'Kiến trúc', value: 'architecture' },
  { label: 'Xây dựng', value: 'construction' },
  { label: 'Thẩm định', value: 'appraisal' },
]

export const SERVICE_STATUS = [
  { label: 'Chưa bắt đầu', value: 'not_started', color: 'info' },
  { label: 'Trong chiến dịch', value: 'in_campaign', color: 'warning' },
  { label: 'Kết thúc', value: 'ended', color: 'secondary' },
]
